export function socials() {
    $(".prettySocial").prettySocial();
}


// WEBPACK FOOTER //
// ./assets/js/modules/socials.js